<ng-container *ngIf="formData && !isLoading; else loadingTemplate">
   <form [formGroup]="formData" class="budget-details">
      <div class="timeStamp">
        {{ startDateFormatted }} - {{ endDateFormatted }}
      </div>
      <div class="details-panel">
         <!--Owner-->
         <div class="details-form-field w-50">
            <div class="icon-container">
               <fa-duotone-icon [icon]="['fad', 'user-crown']" [size]="'2x'"></fa-duotone-icon>
            </div>
            <mat-form-field [id]="'campOwner'" appearance="outline" class="p-form-field-outline">
               <mat-label>Owner</mat-label>
               <mat-select
               [placeholder]="'Owner *'"
               formControlName="ownerId"
               required
               (selectionChange)="onOwnerChanged($event)"
               [panelClass]="'reset-panel-width'"
               >
               <mat-option *ngFor="let item of ownerOptions" [value]="item?.id">
               {{item?.title}}
               </mat-option>
               </mat-select>
               <mat-error *ngIf="formData.controls['ownerId'].hasError('required')">
                  Owner is required
               </mat-error>
            </mat-form-field>
         </div>
         <!--Parent-->
         <div class="details-form-field w-50">
            <div class="icon-container">
               <fa-duotone-icon [icon]="['fad', 'piggy-bank']" [size]="'2x'"></fa-duotone-icon>
            </div>
            <mat-form-field appearance="outline" class="p-form-field-outline">
               <mat-label>Budget Amount({{ companyCurrency?.code }})</mat-label>
               <input matInput
                  formControlName="amount"
                  currencyMask
                  [options]="currencyMaskOptions"/>
            </mat-form-field>
         </div>
         <div class="details-form-field w-50">
            <div class="icon-container">
               <fa-duotone-icon [icon]="['fad', 'hourglass-half']" [size]="'2x'"></fa-duotone-icon>
            </div>
            <mat-form-field [id]="'campOwner'" appearance="outline" class="p-form-field-outline">
               <mat-label>Timeframe Type</mat-label>
               <mat-select
               [placeholder]="'Timeframe Type *'"
               formControlName="timeframeType"
               required
               (selectionChange)="onTimeframeTypeChanged($event)"
               [panelClass]="'reset-panel-width'"
               >
               <mat-option *ngFor="let item of timeframeTypes" [value]="item.id">
               {{item.title}}
               </mat-option>
               </mat-select>
            </mat-form-field>
         </div>
         <!-- Start Date -->
         <div class="details-form-field w-50">
            <div class="icon-container">
               <fa-duotone-icon [icon]="['fad', 'calendar-day']" [size]="'2x'"></fa-duotone-icon>
            </div>
            <mat-form-field appearance="outline" class="p-form-field-outline">
               <mat-label>Fiscal Year Start Date</mat-label>
               <input matInput [matDatepicker]="pickerStartDate"
               formControlName="startDate"
               autocomplete="off"
               (focus)="$event.target.select()"
               (mousedown)="pickerStartDate.open()"/>
               <mat-datepicker #pickerStartDate></mat-datepicker>
            </mat-form-field>
         </div>
         <div>
            <!-- Forecast Toggle Budget settings -->
            <div class="forecast-toggle-holder">
               <ng-container *ngIf="!canDisableForecast; else editableToggle">
                  <mat-slide-toggle
                     [checked]="formData.get('forecastEnabled')?.value"
                     [matTooltip]="disabledForecastTooltip"
                     [disabled]="true"
                     matTooltipPosition="above"
                     matTooltipClass="dark-theme-tooltip above multi-line"
                     matTooltipShowDelay="300"
                     disableRipple
                     class="readonly-toggle"
                  >
                     Forecast Column
                  </mat-slide-toggle>
               </ng-container>

               <!-- Real toggle with formControl -->
               <ng-template #editableToggle>
                  <mat-slide-toggle
                     formControlName="forecastEnabled"
                     disableRipple
                  >
                     Forecast Column
                  </mat-slide-toggle>
               </ng-template>
               <fa-icon 
               [icon]="['fas', 'info-circle']" 
               class="forecast-info-icon" 
               [matTooltip]="forecastTooltip"
               matTooltipClass="dark-theme-tooltip above multi-line"
               matTooltipPosition="above"
               matTooltipShowDelay="300"
               ></fa-icon>
            </div>
         </div>
         <ng-container *ngIf="isForecastEnabled && isFAB">
            <div class="smartcell-area">
               <div class="smartcell-selection-area">
                  <h3 class="column-header">Smart Cell</h3>
                  <fa-icon 
                     [icon]="['fas', 'info-circle']" 
                     class="forecast-info-icon" 
                     [matTooltip]="smartCellTooltip"
                     matTooltipClass="dark-theme-tooltip above multi-line"
                     matTooltipPosition="above"
                     matTooltipShowDelay="300"
                     ></fa-icon>
               </div>
               <div class="smart-cell-options">
                  <mat-radio-group
                     [formControl]="selectedSmartCellOption"
                     color="primary"
                     name="selectedSmartCellOption"
                  >
                     <mat-radio-button value="budget">Total Budget</mat-radio-button>
                     <mat-radio-button value="forecast">Forecast</mat-radio-button>
                  </mat-radio-group>
               </div>
            </div>
         
         </ng-container>

      </div>
      <div class="details-panel budget-formulea-panel">
         <h2 class="panel-floating-title">Custom Available Budget</h2>
         <p>Updating the Available Budget calculation will change values across Manage Campaigns, Expense Groups, and their detail view.</p>
         <p>You can edit this later if needed, but review all affected areas before proceeding. <a [href]="learnMoreHelpLink" target="_blank">Learn More</a></p>
         <h3 class="column-header">Columns</h3>
         <div class="selection-area">
            <ul class="selection-list">
               <li *ngFor="let item of formulaCheckboxOptions">
                  <mat-checkbox
                    color="primary"
                    [(ngModel)]="item.selected"
                    [ngModelOptions]="{ standalone: true }"
                    (change)="onCheckboxChange($event.checked, item)"
                    class="selection-checkbox"
                    [disabled]="item.disabled"
                  >
                    {{ item.label }}
                  </mat-checkbox>

               </li>
            </ul>
         </div>
         <div class="formula-area">
            <cab-configuration-formula-builder
            [selectedItems]="selectedItems"
            [isOnBudgetPage]="true"
            [nonHighlightedFormulaItem]="nonHighlightedFormulaItem"
            >
            </cab-configuration-formula-builder>
         </div>
      </div>
   </form>
</ng-container>

<ng-template #loadingTemplate>
   <div class="loading-container">
      <loader [isVisible]="isLoading"></loader>
   </div>
</ng-template>

<ng-template #captchaTemplate>
  <div class="captcha-content">
    <p>To proceed, enter the word ‘DISABLE’ in the box below</p>
    <input type="text" placeholder="DISABLE" [(ngModel)]="captchaInput" (input)="onCaptchaInputChange()" />
  </div>
</ng-template>
